import { defineNuxtPlugin, useNuxtApp } from '#imports'
import { watchEffect } from 'vue'

import { useClientOnlyComputedBreakpoint } from '@backmarket/utils/composables/useClientOnlyComputedBreakpoint'
import { BreakpointQueries } from '@backmarket/utils/dom/getCurrentBreakpoint'

/**
 * Track the breakpoints and send the data to the tracking module.
 */
export default defineNuxtPlugin({
  name: 'trackResize',
  setup: () => {
    const { $tracking } = useNuxtApp()

    const currentBreakpoint = useClientOnlyComputedBreakpoint()
    watchEffect(() => {
      $tracking.trackResize({
        breakpointValue: currentBreakpoint.value,
        breakpointRule: BreakpointQueries[currentBreakpoint.value],
      })
    })
  },
})
